module.exports = __webpack_public_path__ + "img/_4.934e3923.png";